import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'mojoHighlight' })
export class HighlightPipe implements PipeTransform {
  transform(text: string, words: string[]): SafeHtml {
    if (words && text) {
      // make sure text is clean
      const pattern = words
        .map((word) => `\\b(${word.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')})\\b`)
        .join('|');
      const regex = new RegExp(pattern, 'gi');
      return text.replace(regex, (match) => `<span class="highlight">${match}</span>`);
    } else {
      return text;
    }
  }
}
